import {
  createGetApplyNewBetDateModel,
  IGetApplyNewBetDateSuccessResponseSchema,
  IGetApplyNewBetDateErrorResponseSchema,
} from '@cian/api-models/auction/v1/get-apply-new-bet-date-by-announcement';
import { IHttpApi } from '@cian/http-api';

export const getApplyNewBetDate = (httpApi: IHttpApi, announcementId: number) => {
  return httpApi.fetch(createGetApplyNewBetDateModel({ parameters: { announcementId } }))
    .then(({ response, statusCode }) => {
      if (statusCode === 400) {
        throw response as IGetApplyNewBetDateErrorResponseSchema;
      }

      return response as IGetApplyNewBetDateSuccessResponseSchema;
    });
};
